import { Bug } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { sentryWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  sentryWeb,
  {
    SentryPage: () => import('./SentryPage'),
    SentryProjectDetailPage: () => import('./SentryProjectDetailPage'),
    SentryFlowTriggerSummary: () => import('./SentryFlowTriggerSummary'),
    SentryIssueContextProvider: () => import('./SentryIssueContextProvider'),
    SentryPagePreview: () =>
      import('./SentryPagePreview').then((m) => ({ default: m.SentryPagePreview })),
  },
  {
    icons: { Bug },
  },
);
